'use client';

import { Content } from '@prismicio/client';
import { JSXMapSerializer, PrismicRichText } from '@prismicio/react';
import type { Simplify } from '../../../../prismicio-types';
import { Container } from '@/components';

import { HistoryCards } from './HistoryCards/HistoryCards';
import { useVisible } from '@/hooks';
import styles from './ourHistoryInner.module.scss';

interface OurHistoryInnerProps {
  data: Simplify<Content.OurHistorySliceDefaultPrimary>;
}

const components: JSXMapSerializer = {
  heading2: ({ children }) => <h2 className={styles.title}>{children}</h2>,
  paragraph: ({ children }) => <p className={styles.paragraph}>{children}</p>,
};

export const OurHistoryInner = ({ data }: OurHistoryInnerProps) => {
  const [isVisible, id] = useVisible();

  const isVisibleStyles = isVisible ? styles.isVisible : '';
  return (
    <Container id={id}>
      <article className={styles.history_wrapper}>
        <div className={`${styles.title_wrapper} ${isVisibleStyles}`}>
          <PrismicRichText field={data.title} components={components} />
        </div>
        <div className={`${styles.history} ${isVisibleStyles}`}>
          <PrismicRichText field={data.history} components={components} />
        </div>
      </article>
      <HistoryCards data={data} />
    </Container>
  );
};
